import React from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

interface ExpandToggleCellProps {
  expanded: boolean;
}

const ExpandToggleCell = ({ expanded }: ExpandToggleCellProps) => {
  return (
    <div className="flex justify-center items-center w-24">
      {expanded ? (
        <ChevronUp size={20} aria-hidden="true" />
      ) : (
        <ChevronDown size={20} aria-hidden="true" />
      )}
    </div>
  );
};

export default ExpandToggleCell;
